module.exports = __webpack_public_path__ + "img/dep_gamestoysandsports.9b1ee19d.png";